import { useTranslation } from 'react-i18next';

import { ApplicationLogo } from 'components/Logo/ApplicationLogo/ApplicationLogo';

export const PoweredByFooter = () => {
  const { t } = useTranslation();
  return (
    <div className="flex items-center gap-3 rounded-full px-0 py-2">
      <ApplicationLogo variant="dark" withText={false} className="h-4" />
      <span className="text-xs leading-4 text-gray-500">
        {t('common:poweredBy')}{' '}
        <a
          href="https://procuros.io/"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-gray-700 hover:text-gray-900"
        >
          Procuros
        </a>
      </span>
    </div>
  );
};
